export const DEALER_MARKETING_OPTIN_INFO_CLAUSE_espot =
  'DEALER_MARKETING_OPTIN_INFO_CLAUSE_espot';
export const LOCAL_COMPLIANCE_espot = 'LOCAL_COMPLIANCE_espot';
export const DEALER_LOCAL_COMPLIANCE_Info_espot =
  'DEALER_LOCAL_COMPLIANCE_Info_espot';
export const DEALER_LOCAL_COMPLIANCE_Details_espot =
  'DEALER_LOCAL_COMPLIANCE_Details_espot';
